import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Company } from '../../interfaces/Company/Company';
import { getCompanies } from '../../api/Company';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { CompaniesTable } from './CompaniesTable';

export const CompaniesPage = () => {
  const navigate = useNavigate();

  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshCompanies = () => {
    setLoading(true);
    getCompanies()
      .then((c) => setCompanies(c))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshCompanies();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Bayiler / Üye Grupları
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/users/companies/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Bayi
      </Button>
      <CompaniesTable companies={companies} />
    </Box>
  );
};
